import { Stack } from '@mui/material';

import { ColorPickerWithLabel } from '@occc-app/design-system';

export const StoreBranding = () => {
  return (
    <Stack direction='row' spacing={3}>
      <ColorPickerWithLabel name='details.brandingDetails.primaryColor' label='Primary Color' />
      <ColorPickerWithLabel name='details.brandingDetails.secondaryColor' label='Secondary Color' />
    </Stack>
  );
};
